import { MDBCard, MDBCardBody, MDBCardText, MDBCol, MDBRow } from "mdbreact";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  Container,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";
import usePutAuthed from "../../helpers/hooks/usePutAuthed";
import dropdown from "../../dropdown.json";
import useDeleteAuthed from "../../helpers/hooks/useDeleteAuthed";
import { useHistory } from "react-router-dom";
import useGetAuthed from "../../helpers/hooks/useGetAuthed";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ProposedChangesModal from "./Modals/ProposedChangesModal";
import toastr from "toastr";
import moment from "moment";
import ProposedHistoryModal from "./Modals/ProposedHistoryModal";

function LoanDetail(props) {
  // get params
  const { id, loanId } = useParams();
  console.log({ id, loanId });
  const history = useHistory();

  // states
  const [event, setEvent] = useState("");
  const [feilds, setFeilds] = useState("");
  // const [loanId, setLoanId] = useState('')
  const [modal, setModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRevision, setIsResvision] = useState(false);
  const [revisionModal, setRevisionModal] = useState(false);
  const [revisionModalData, setRevisionModalData] = useState([]);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);

  const isSmallScreen = window.innerWidth <= 500;
  const isLargeScreen = window.innerWidth >= 500;

  // use hooks
  const [getData, getError, getLoading, getCall] = useGetAuthed(
    `get_loan_application/${id}`,
    true,
    "loan"
  );
  const [call, data, error, loading] = usePutAuthed(
    `update_loan_application/${id}`,
    "loan"
  );
  const [deleteCall, deleteData, deleteError, deleteLoading] = useDeleteAuthed(
    `delete_loan_application/${id}`,
    "loan"
  );

  // Chack bankAdmin token
  const bankAdmin = JSON.parse(localStorage.getItem("bankAdmin"));

  // functions
  const updateData = () => {
    call(feilds);
    setEvent("Updated");
  };

  const deleteFun = () => {
    deleteCall();
  };

  const toggleModal = () => {
    // setIsResvision(bool)
    setModal(!modal);
  };

  const toggleRevision = () => {
    setRevisionModal(!revisionModal);
  };

  const toggleDeleteConfirmationModal = () => {
    setDeleteConfirmationModal(!deleteConfirmationModal);
  };

  const handleDeleteConfirmation = () => {
    toggleDeleteConfirmationModal();
    deleteFun();
  };

  const getOptions = (id) => {
    let option = [];
    dropdown.map((x) => {
      if (x.id === id) {
        option = x.list_english;
      }
    });
    return option;
  };

  useEffect(() => {
    if (getData) {
      console.log(getData[0]["loan_application"]);
      setFeilds(getData[0]["loan_application"]);
      setIsLoading(true);
      console.log(
        !getData[0]["loan_application"]?.ismodified &&
          !getData[0]["loan_application"]?.user_response
      );
    }
    // if(revisionData?.length > 0){
    //     setRevisionModalData(revisionModalData)
    //     console.log({revisionData})
    // }
  }, [getData]);

  useEffect(() => {
    if (error) {
      console.log("Data did not updated", error);
      toastr.error(error);
    }
    // if (deleteError) {
    //   console.log('Application did not deleted', deleteError)
    //   toastr.error(deleteError)
    // }
  }, [error, deleteError]);

  useEffect(() => {
    if (data) {
      console.log({ data });
      setFeilds(data);
      // updated(data)
      if (event === "Rejected") {
        toastr.error(`Application has been ${event}`);
        return;
      }
      // toastr.success(`Application has been ${event}`)
    }
    if (deleteData) {
      console.log({ deleteData });
      toastr.success("Application has been deleted");
      history.push("/loan");
    }

    if (deleteError) {
      toastr.error(`Error: ${deleteError.detail}`);
    }
  }, [data, deleteData, deleteError]);

  return (
    <React.Fragment>
      <Container fluid>
        <div className="page-content">
          <div className="align-items-center d-flex justify-content-between mb-3 flex-sm-row flex-column">
            <h4>Loan Application</h4>

            {/* changes buttons */}

            <div className={`d-flex ${isSmallScreen ? "flex-column" : "flex-sm-row"}`}>

            {!bankAdmin && !getLoading && (
              <div className="d-flex flex-wrap">
                <div>
                  <Button
                    className="mr-1"
                    color="none"
                    style={{ border: "1px solid blue" }}
                    disabled={!feilds?.ismodified && !feilds?.user_response}
                    onClick={toggleRevision}
                  >
                    Revision History
                  </Button>{" "}
                </div>

                <div>
                  <Button
                    className="bg-primary mr-1"
                    onClick={toggleModal}
                    disabled={feilds?.ismodified}
                  >
                    Propose Changes
                  </Button>{" "}
                </div>
              </div>
            )}



            {/* update and delete buttons */}
            {!bankAdmin && (
              <div className="d-flex flex-wrap">
                {/* <Button
                                className='bg-primary mr-1'
                                onClick={updateData}
                            >Update</Button>{' '} */}
                <Button
                  className="bg-danger mr-1"
                  onClick={toggleDeleteConfirmationModal}
                >
                  Delete
                </Button>{" "}
              </div>
            )}
          </div>
          
          </div>
          
          {/* Modal for the propsed changes */}
          {!getLoading && (
            <ProposedChangesModal
              modal={modal}
              toggleModal={toggleModal}
              feilds={feilds}
              getOptions={getOptions}
              getCall={getCall}
            />
          )}

          {!getLoading && (
            <ProposedHistoryModal
              modal={revisionModal}
              toggleModal={toggleRevision}
              loanId={loanId}
            />
          )}

          {!getLoading && (
            <Modal
              isOpen={deleteConfirmationModal}
              toggle={toggleDeleteConfirmationModal}
            >
              <ModalHeader toggle={toggleDeleteConfirmationModal}>
                Confirm Delete
              </ModalHeader>
              <ModalBody>Are you sure you want to delete?</ModalBody>
              <ModalFooter>
                <Button color="danger" onClick={handleDeleteConfirmation}>
                  Delete
                </Button>{" "}
                <Button
                  color="secondary"
                  onClick={toggleDeleteConfirmationModal}
                >
                  Cancel
                </Button>
              </ModalFooter>
            </Modal>
          )}

          {getLoading ? (
            <Card>
              <CardBody className="text-center">
                <Spinner className="mr-2" color="primary"></Spinner>
              </CardBody>
            </Card>
          ) : (
            <MDBCard className="mb-4">
              <MDBCardBody>
                {/* {feilds['loan_id'] && (
                <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Loan Id</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      readOnly //onChange={(e) => { setFeilds({ ...feilds, 'loan_status': +e.target.value }) }}
                      className="text-muted"
                      value={feilds["loan_id"]}
                    ></Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
              )} */}
                {/* <MDBRow>
                                    <MDBCol sm="5">
                                        <MDBCardText>Loan Status</MDBCardText>
                                    </MDBCol>
                                    <MDBCol sm="7">
                                        <Input type='select' onChange={(e) => { setFeilds({ ...feilds, 'loan_status': +e.target.value }) }}
                                            className="text-muted" value={feilds['loan_status']}
                                        >
                                            <option key='1' value='1' >Approved</option>
                                            <option key='2' value='0' >Pending</option>
                                            <option key='3' value='-1' >Reject</option>
                                        </Input>
                                    </MDBCol>
                                </MDBRow> */}
                {/* {feilds['cnic'] && (   
                          <>       */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Date</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      readOnly
                      // onChange={(e) => { setFeilds({ ...feilds, 'cnic': e.target.value }) }}
                      className="text-muted"
                      value={moment(feilds["createdAt"]).format("DD-MM-YYYY")}
                    />
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                             )} */}

                {/* {feilds['cnic'] && (
<> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>CNIC</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      readOnly
                      // onChange={(e) => { setFeilds({ ...feilds, 'cnic': e.target.value }) }}
                      className="text-muted"
                      value={feilds["cnic"]}
                    />
                  </MDBCol>
                </MDBRow>
                <hr />
                <MDBRow>
                  {/* oooooooooooooooo */}

                  <MDBCol sm="5">
                    <MDBCardText>
                      Picture Upload Option
                      {/* {!feilds['pic_upload_option'] && <i className='ri-error-warning-line font-size-20 ml-2' style={{ color: '#FFB911D1' }}></i>} */}
                    </MDBCardText>
                  </MDBCol>
                  {/* {!feilds['pic_upload_option'] && <i className='ri-error-warning-line font-size-20 ml-2' style={{ color: '#FFB911D1' }}></i>}  */}
                  <MDBCol sm="7">
                    <Input
                      // onChange={(e) => { setFeilds({ ...feilds, 'pic_upload_option': e.target.value }) }}
                      readOnly
                      className="text-muted"
                      value={feilds["pic_upload_option"]}
                    />
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['land_ownership'] && (
                <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Land Ownership</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          land_ownership: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["land_ownership"]}
                    >
                      {getOptions(449).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['plra_registered'] && (
<> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Plra Registered</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          plra_registered: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["plra_registered"]}
                    >
                      {getOptions(456).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
)} */}

                {/* {feilds['land_size_acres'] && (
<> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Land Size Acres</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          land_size_acres: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["land_size_acres"]}
                    >
                      {/* {
                                                getOptions(450).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['khasra_no'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Khasra No</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({ ...feilds, khasra_no: e.target.value });
                      }}
                      className="text-muted"
                      value={feilds["khasra_no"]}
                    />
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['khewat_no'] && (
<> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Khewat No</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({ ...feilds, khewat_no: e.target.value });
                      }}
                      className="text-muted"
                      value={feilds["khewat_no"]}
                    />
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}
                {/* {feilds['desired_crop'] && (
<> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Desired Crop</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({ ...feilds, desired_crop: e.target.value });
                      }}
                      className="text-muted"
                      value={feilds["desired_crop"]}
                    >
                      {getOptions(442).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['crop_sowing_month'] && (
<> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Crop Sowing Month</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          crop_sowing_month: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["crop_sowing_month"]}
                    >
                      {getOptions(441).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['crop_harvest_month'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Crop Harvest Month</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          crop_harvest_month: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["crop_harvest_month"]}
                    >
                      {getOptions(439).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['marital_status'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>
                      Marital Status
                      {/* {!feilds["marital_status"] && (
                        <i
                          className="ri-error-warning-line font-size-20 ml-2"
                          style={{ color: "#FFB911D1" }}
                        ></i>
                      )} */}
                    </MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'}
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          marital_status: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["marital_status"]}
                    >
                      {/* {
                                                getOptions(452).map((x) => {
                                                    if (!bankAdmin) return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['family_members'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>
                      Family Members
                      {/* {!feilds["family_member"] && (
                        <i
                          className="ri-error-warning-line font-size-20 ml-2"
                          style={{ color: "#FFB911D1" }}
                        ></i>
                      )} */}
                    </MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          family_members: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["family_members"]}
                    >
                      {/* {
                                                getOptions(454).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['education'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>
                      Education
                      {/* {!feilds["education"] && (
                        <i
                          className="ri-error-warning-line font-size-20 ml-2"
                          style={{ color: "#FFB911D1" }}
                        ></i>
                      )} */}
                    </MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'}
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({ ...feilds, education: e.target.value });
                      }}
                      className="text-muted"
                      value={feilds["education"]}
                    >
                      {/* {
                                                getOptions(443).map((x) => {
                                                    if (!bankAdmin) return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['house_ownership'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>House Ownership</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          house_ownership: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["house_ownership"]}
                    >
                      {getOptions(445).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['agri_experience'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>
                      Agricultural Experience
                      {/* {!feilds["agri_experience"] && (
                        <i
                          className="ri-error-warning-line font-size-20 ml-2"
                          style={{ color: "#FFB911D1" }}
                        ></i>
                      )} */}
                    </MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          agri_experience: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["agri_experience"]}
                    >
                      {/* {
                                                getOptions(444).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['type_of_irrigation'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Type of Irrigation</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          type_of_irrigation: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["type_of_irrigation"]}
                    >
                      {getOptions(480).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['previous_experience_with_same_crop'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>
                      Previous Experience With Same Crop
                    </MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          previous_experience_with_same_crop: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["previous_experience_with_same_crop"]}
                    >
                      {getOptions(473).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['avg_yield_per_acre_last_year'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Average Yield Per Acre Last Year</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          avg_yield_per_acre_last_year: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["avg_yield_per_acre_last_year"]}
                    >
                      {/* {
                                                getOptions(437).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['availability_of_latest_irrigation_systems'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>
                      Availability of Latest Irrigation Systems
                    </MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          availability_of_latest_irrigation_systems:
                            e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={
                        feilds["availability_of_latest_irrigation_systems"]
                      }
                    >
                      {getOptions(436).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['produce_selling_medium'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Produce Selling Medium</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          produce_selling_medium: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["produce_selling_medium"]}
                    >
                      {getOptions(474).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['livestock_ownership'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Livestock Ownership</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          livestock_ownership: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["livestock_ownership"]}
                    >
                      {/* {
                                                getOptions(451).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['agricultural_machinery_ownership'] && (
  <> */}
                {/* {!bankAdmin && !feilds['agricultural_machinery_ownership'] &&  */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Agricultural Machinery Ownership</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          agricultural_machinery_ownership: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["agricultural_machinery_ownership"]}
                    >
                      {/* {
                                                getOptions(435).map((x) => {
                                                   if(!bankAdmin) return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                {/* } */}
                {<hr />}
                {/* </>
                  )} */}

                {/* {feilds['household_assets'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Household Assets</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          household_assets: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["household_assets"]}
                    >
                      {getOptions(446).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['motorcycle_ownership'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Motorcycle Ownership</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'}
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          motorcycle_ownership: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["motorcycle_ownership"]}
                    >
                      {/* {
                                                getOptions(453).map((x) => {
                                                    if (!bankAdmin) return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
)} */}

                {/* {feilds['crop_insurance_history'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Crop Insurance History</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          crop_insurance_history: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["crop_insurance_history"]}
                    >
                      {getOptions(440).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* Quantities and Brands */}

                {/* {feilds['required_urea_quantity'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Required Urea Quantity</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          required_urea_quantity: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["required_urea_quantity"]}
                    >
                      {/* {
                                                getOptions(479).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['preferred_urea_brand'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Urea Brand</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_urea_brand: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_urea_brand"]}
                    >
                      {getOptions(468).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['required_dap_quantity'] && (
                    <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Required Dap Quantity</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          required_dap_quantity: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["required_dap_quantity"]}
                    >
                      {/* {
                                                getOptions(476).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['preferred_dap_brand'] && (
                    <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Dap Brand</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_dap_brand: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_dap_brand"]}
                    >
                      {getOptions(457).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['preferred_zinc_quantity'] && (
                    <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Zinc Quantity</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_zinc_quantity: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_zinc_quantity"]}
                    >
                      {/* {
                                                getOptions(472).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['preferred_zinc_brand'] && (
                    <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Zinc Brand</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_zinc_brand: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_zinc_brand"]}
                    >
                      {getOptions(471).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['preferred_sop_quantity'] && (
  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Sop Quantity</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_sop_quantity: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_sop_quantity"]}
                    >
                      {/* {
                                                getOptions(467).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['preferred_sop_brand'] && (
                    <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Sop Brand</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_sop_brand: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_sop_brand"]}
                    >
                      {getOptions(466).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['preferred_np_quantity'] && (
                    <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Np Quantity</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_np_quantity: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_np_quantity"]}
                    >
                      {/* {
                                                getOptions(463).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                  )} */}

                {/* {feilds['preferred_np_brand'] && (
                    <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Np Brand</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_np_brand: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_np_brand"]}
                    >
                      {getOptions(462).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['preferred_mop_quantity'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Mop Quantity</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_mop_quantity: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_mop_quantity"]}
                    >
                      {/* {
                                                getOptions(461).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['preferred_mop_brand'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Mop Brand</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_mop_brand: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_mop_brand"]}
                    >
                      {getOptions(460).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['required_pesticides_quantity'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Required Pesticides Quantity</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          required_pesticides_quantity: e.target.value,
                        });
                      }}
                      Text
                      className="text-muted"
                      value={feilds["required_pesticides_quantity"]}
                    >
                      {/* {
                                                getOptions(477).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['preferred_pesticides_brand'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Pesticides Brand</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_pesticides_brand: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_pesticides_brand"]}
                    >
                      {getOptions(464).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['preferred_weedicide_quantity'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Weedicide Quantity</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_weedicide_quantity: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_weedicide_quantity"]}
                    >
                      {/* {
                                                getOptions(470).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['preferred_weedicide_brand'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Weedicide Brand</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_weedicide_brand: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_weedicide_brand"]}
                    >
                      {getOptions(469).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['preferred_fungicide_quantity'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Fungicide Quantity</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_fungicide_quantity: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_fungicide_quantity"]}
                    >
                      {/* {
                                                getOptions(459).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* EDITED BY */}
                {/* {feilds['preferred_fungicide_brand'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Fungicide Brand</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_fungicide_brand: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_fungicide_brand"]}
                    >
                      {getOptions(458).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}
                {/* {feilds['required_seeds_quantity_kgs'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Required Seeds Quantity Kgs</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // readOnly={bankAdmin}
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          required_seeds_quantity_kgs: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["required_seeds_quantity_kgs"]}
                    >
                      {/* {
                                                getOptions(478).map((x) => {
                                                    return <option key={x} value={x} >{x}</option>
                                                })
                                            } */}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['preferred_seeds_company'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Preferred Seeds Company</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      // type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          preferred_seeds_company: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["preferred_seeds_company"]}
                    >
                      {getOptions(465).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                <hr />
                {/* </>
                )} */}

                {/* {feilds['rental_machinery_requirement'] && (
                  <> */}
                <MDBRow>
                  <MDBCol sm="5">
                    <MDBCardText>Rental Machinery Requirement</MDBCardText>
                  </MDBCol>
                  <MDBCol sm="7">
                    <Input
                      //  type={!bankAdmin ? 'select' : 'text'} readOnly={bankAdmin}
                      type="text"
                      readOnly
                      onChange={(e) => {
                        setFeilds({
                          ...feilds,
                          rental_machinery_requirement: e.target.value,
                        });
                      }}
                      className="text-muted"
                      value={feilds["rental_machinery_requirement"]}
                    >
                      {getOptions(475).map((x) => {
                        if (!bankAdmin)
                          return (
                            <option key={x} value={x}>
                              {x}
                            </option>
                          );
                      })}
                    </Input>
                  </MDBCol>
                </MDBRow>
                {/* </>
                )} */}
              </MDBCardBody>
            </MDBCard>
          )}
        </div>
      </Container>
    </React.Fragment>
  );
}

export default LoanDetail;
